interface LogomarkProps {
  size?: number;
  className?: string;
}

export const Logomark = ({ size = 22, className }: LogomarkProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 86 86"
    className={className}
    style={{ display: 'block' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M45.5167 22.7596C45.5167 13.2624 53.228 5.55112 62.7252 5.55112C72.2224 5.55112 79.9337 13.2624 79.9337 22.7596C79.9337 32.2568 72.2224 39.9681 62.7252 39.9681H55.5099V45.5192H62.7252C75.2882 45.5192 85.4848 35.3226 85.4848 22.7596C85.4848 10.1966 75.2882 0 62.7252 0C50.1622 0 39.9656 10.1966 39.9656 22.7596V29.9762H45.5167V22.7596ZM39.9681 55.5114H45.5192V62.7281C45.5192 75.2911 35.3226 85.4877 22.7596 85.4877C10.1966 85.4877 0 75.2911 0 62.7281C0 50.1651 10.1966 39.9685 22.7596 39.9685H29.9748V45.5196H22.7596C13.2624 45.5196 5.55112 53.2309 5.55112 62.7281C5.55112 72.2253 13.2624 79.9366 22.7596 79.9366C32.2568 79.9366 39.9681 72.2253 39.9681 62.7281V55.5114Z"
    />
    <circle cx="42.75" cy="42.75" r="5.2" fill="var(--periwinkle)" />
  </svg>
);
